import { Col, Row, Table } from "react-bootstrap";
import Text from "../_widgets/Text/Text";
import NavBar from "../_widgets/NavBar/NavBar";
import AnimatedPage from "../AnimatedPage/AnimatedPage";
import MainLoader from "../_widgets/Loader/MainLoader";
import CustomPagination from "../_widgets/Pagination/Pagination";
import IconResource from "../../Wrapper/IconResource/IconResource";
import {
  capitalizeFirstLetter,
  capitalizeWords,
  isNullOrEmpty,
  removeUnderscores,
} from "../../Utils/stringUtils";
import { changeDateTimeFormatForDisplay } from "../../Utils/dateUtils";
import MultiSelectDropdown from "../_widgets/MultiSelect/MultiSelectDropdown";
import Input from "../_widgets/Input/Input";
import DateRangePicker from "../_widgets/DateRangePicker/DateRangePicker";
import { getColorFromStatus } from "../../Utils/appUtils";
import ImageResource from "../../Wrapper/ImageResource/ImageResource";

const NotificationLogsUI = ({
  loading,
  list,
  onPageChange,
  selectedOptions,
  searchQuery,
  setSearchQuery,
  dates,
  setDates,
  clearFilter,
  handleDropdownChange,
  fetchNotifications,
  datePickerStartRef,
  datePickerEndRef,
  saleDatePickerStartRef,
  saleDatePickerEndRef,
  categories,
}) => {
  return (
    <AnimatedPage>
      <NavBar
        heading={"Notification Logs"}
        onClick={() => {
          document.body.classList.toggle("side_active");
          document.body.classList.toggle("side_active_mb");
        }}
        Icon="menu"
      />

      <div className="patient_list white_card mt-3">
        <div className="top_bar">
          <Text type="h2" text={"Notification Logs"} />

          <div className="d-flex align-items-start align-items-md-center gap-3">
            <div className="bg_grey d-flex align-items-center justify-content-center position-relative px-2 py-1">
              {selectedOptions.length > 0 ? (
                <div className="round-notification">{selectedOptions.length}</div>
              ) : (
                ""
              )}

              <MultiSelectDropdown
                items={categories}
                name={
                  <div className="d-flex align-items-center gap-1">
                    <IconResource type={"filter"} size={12} color={"var(--primary)"} />
                    <small
                      style={{
                        fontSize: "12px",
                        fontWeight: "bold",
                        color: "var(--primary)",
                        cursor: "pointer",
                      }}
                      className=""
                    >
                      Type
                    </small>
                    {selectedOptions.length > 0 ? (
                      <IconResource type={"cross"} size={12} onClick={clearFilter} />
                    ) : (
                      ""
                    )}
                  </div>
                }
                selectedOptions={selectedOptions}
                onChange={handleDropdownChange}
              />
            </div>
            <Row className="search_filter">
              <Col lg={4}>
                <div>
                  <Input
                    placeholder="Search"
                    id="searchInput"
                    suffixIcon="search"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    onClickIconSuff={() => fetchNotifications()}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        fetchNotifications();
                      }
                    }}
                    iconTooltip="Search"
                  />
                </div>
              </Col>
              <Col lg={8}>
                <div className="date_range_picker">
                  <DateRangePicker
                    startDate={dates?.startDate}
                    setStartDate={(startDate) => setDates({ ...dates, startDate })}
                    endDate={dates?.endDate}
                    setEndDate={(endDate) => setDates({ ...dates, endDate })}
                    onChange={(startDate, endDate) => setDates({ startDate, endDate })}
                    datePickerStartRef={datePickerStartRef}
                    datePickerEndRef={datePickerEndRef}
                    saleDatePickerStartRef={saleDatePickerStartRef}
                    saleDatePickerEndRef={saleDatePickerEndRef}
                    showDateShortcuts={true}
                  />
                </div>
              </Col>
            </Row>
          </div>
        </div>

        <div className="custom_table position-relative">
          {loading ? (
            <MainLoader />
          ) : list?.data?.length > 0 ? (
            <>
              <Table responsive>
                <thead>
                  <tr>
                    <th>To Number</th>
                    <th>Type</th>
                    <th>WA Response</th>
                    <th>WA Status</th>
                    <th>Status</th>
                    <th>Scheduled Time</th>
                  </tr>
                </thead>
                <tbody>
                  {list?.data?.map((notification) => (
                    <tr key={notification?.id}>
                      <td>{notification?.to_number ?? "-"}</td>
                      <td>{capitalizeWords(removeUnderscores(notification?.type))}</td>
                      <td>
                        {notification?.wa_response !== null
                          ? (() => {
                              try {
                                const parsed = JSON.parse(notification.wa_response);
                                if (parsed.error) {
                                  return "-";
                                }
                                return parsed.whatsapp_logs?.map((log, index) => (
                                  <div className="small" key={index}>
                                    UID: {log.uid} <br />
                                    Created At: {changeDateTimeFormatForDisplay(log.created_at)}
                                  </div>
                                ));
                              } catch (e) {
                                return <span>Invalid JSON</span>;
                              }
                            })()
                          : "-"}
                      </td>{" "}
                      <td>
                        <div
                          className={`status status__${getColorFromStatus(
                            notification?.wa_status,
                          )}`}
                        >
                          {!isNullOrEmpty(notification?.wa_status)
                            ? capitalizeFirstLetter(notification?.wa_status)
                            : "-"}
                        </div>
                      </td>
                      <td>
                        <div
                          className={`status status__${getColorFromStatus(notification?.status)}`}
                        >
                          {capitalizeFirstLetter(notification?.status)}
                        </div>
                      </td>
                      <td>
                        {changeDateTimeFormatForDisplay(notification?.schedule_date_time) ?? "-"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <CustomPagination
                activePage={list?.current_page}
                onPageChange={onPageChange}
                pageLength={list?.per_page}
                totalData={list?.total}
                lastPage={list?.last_page}
              />
            </>
          ) : (
            <div className="no_data position-relative">
              <ImageResource type="noData" style={{ width: "300px" }} className="img-fluid" />
              <Text type="h2" text="There is no data to display." />
            </div>
          )}
        </div>
      </div>
    </AnimatedPage>
  );
};

export default NotificationLogsUI;
